import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';

import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Input, Form, Button, ToggleSwitch, Tooltip, Loading } from 'Components';
import { Grid, Typography, Icon } from '@mui/material';
import InputSearchMap from 'Components/Map/components/InputSearchMap';
import { NotificationManager } from 'Components/Notifications';
import { getRouteColorFromSpeed } from 'Components/Map/utils';

// International
import { useIntl } from "react-intl";

import { useGeocoder } from 'Core/hooks';

/*********************************************************
 * Enums or Objects
*********************************************************/
import { TypeObjectMap, TypeLayer } from 'Components/Map/providers/enums'

const defaulColorRoute = "#cacfd2";

import {
    mapSpeedOverrideOpenEditCreateModal,
    mapSpeedOverrideGetSpeedOverride,
    mapSpeedOverrideSaveSpeedOverride,
    drawGetDirections,
    addPointers,
    setMapRoutesOptions,
    setLatLngRestart,
    mapSpeedOverrideClearSearch,
    selectCreateClickMapType,
    clearRedux
} from 'Redux/actions';

import './style.scss';

var routeError = null;
const SpeedOverrideCreateEdit = (props) => {

    const { messages } = useIntl();
    const { mapRef } = props

    const open = useSelector((state) => state.realtimeMapSpeedOverrideCreateEditRedux.open);
    const id = useSelector((state) => state.realtimeMapSpeedOverrideCreateEditRedux.id);
    const speedOverride = useSelector((state) => state.realtimeMapSpeedOverrideCreateEditRedux.speedOverride);
    const loadingSpeedOverride = useSelector((state) => state.realtimeMapSpeedOverrideCreateEditRedux.loadingSpeedOverride);
    const response = useSelector((state) => state.realtimeMapSpeedOverrideCreateEditRedux.response);
    const loadingResponse = useSelector((state) => state.realtimeMapSpeedOverrideCreateEditRedux.loadingResponse);

    const isKph = useSelector((state) => state.securityRedux.user.isKph);

    const {
        pointers,
        directionsError,
        clickLatLng
    } = useSelector((state) => state.realtimeMapRedux);

    const onErrorRoute = (points) => {
        if(!routeError){
            routeError = points;
        } else return;
        setFormData(formData => ({
            ...formData,
            startAddress:  { ...formData?.startAddress, latitude: points[0].lat, longitude: points[0].lng }
        }))

        dispatch(addPointers(points[0]));
        dispatch(drawGetDirections(false));
        //delete the old rounte on map
        mapRef?.current?.deleteRouteInMap()

        dispatch(setLatLngRestart())
        dispatch(selectCreateClickMapType(TypeObjectMap.MapClick))


        NotificationManager.warning(
            messages['realtimemaps_route_limit'],
            messages['realtimemaps_title'],
            3000,
            null,
            null,
            'warning',
            null
        );
    }

    const routeProperties = {
        optimizeWaypoints: true,
        avoidTolls: false,
        avoidHighways: false,
        limit: 50, //limit in miles
        color: "#FF4500",
        draggable: true,
        hideLabelsOnMarkers: false,
        saveCoordinates: true,
        drawSpeedLimits: true,
        isSpeedOverride: true,
        startPointColor:  "#00B200",
        endPointColor:  "#DF1A31",
        onErrorRoute: onErrorRoute
    }

    const [formData, setFormData] = useState({ routeProperties: routeProperties })

    const dispatch = useDispatch();

    const formCreateSpeedOverride = useRef();

    const [onGetGeocoder, address, setAddress] = useGeocoder();



    const handleClose = () => {
        mapRef?.current?.removeLayer(TypeLayer.RouteLayer);
        setFormData({ routeProperties: routeProperties });
        dispatch(selectCreateClickMapType(TypeObjectMap.Default))
        dispatch(setLatLngRestart())

        mapRef?.current?.deleteRouteInMap();
        dispatch(drawGetDirections(false));
        dispatch(addPointers([]));

        dispatch(mapSpeedOverrideOpenEditCreateModal(false, null))
        routeError = null
    }


    useEffect(()=> {
        //start the route options
        dispatch(setMapRoutesOptions(formData?.routeProperties));

        //test get speed override data
        mapRef?.current?.removeLayer(TypeLayer.RouteLayer);

        //is create new object
        dispatch(selectCreateClickMapType(TypeObjectMap.MapClick))

        mapRef?.current?.showLayer(TypeLayer.Units, false);
        mapRef?.current?.hideMarkerModal();
        return () => {
            mapRef?.current?.showUnitsByPreferences();
        }
    },[])

    useEffect(() => {
        if (id && open) {
            dispatch(mapSpeedOverrideGetSpeedOverride(id));
        }
    }, [id, open]);

    useEffect(() => {
        if (
            formData?.startAddress?.latitude &&
            formData?.startAddress?.longitude &&
            formData?.startAddress?.address &&
            formData?.endAddress?.latitude &&
            formData?.endAddress?.longitude &&
            formData?.endAddress?.address
        ) {
            routeError = null
            const startPoint = { latitude: formData?.startAddress?.latitude, longitude: formData?.startAddress?.longitude }
            const endPoint = { latitude: formData?.endAddress?.latitude, longitude: formData?.endAddress?.longitude }
            createRouteOnView(startPoint, endPoint);
        } else if (
            (formData?.startAddress?.latitude && formData?.startAddress?.longitude && formData?.startAddress?.address)
            ||
            (formData?.endAddress?.latitude && formData?.endAddress?.longitude && formData?.endAddress?.address)
        ) {
            routeError = null;
            let pointOnMap = null, start = true;
            if(formData?.startAddress?.latitude){
                pointOnMap = { latitude: formData?.startAddress?.latitude, longitude: formData?.startAddress?.longitude }
            }else if(formData?.endAddress?.latitude){
                start = false;
                pointOnMap = { latitude: formData?.endAddress?.latitude, longitude: formData?.endAddress?.longitude }
            }
            if(!pointOnMap) return
            const tempPointers = [
                {
                    id: '1',
                    lat: parseFloat(pointOnMap?.latitude || 0),
                    lng: parseFloat(pointOnMap?.longitude || 0),
                    label: formData?.startAddress?.address,
                    heading: 0,
                    color: '000',
                    eventName: 'no event',
                    draggable: false,
                    updatePointers: true,
                    hideMarker: false,
                    noZoom: !(mapRef.current.getZoom() < 15),
                    icon: {
                        url: start ? `/assets/icons/pin_destination.png` : `/assets/icons/pin_vehicle.png`,
                        scaledSize: new google.maps.Size(30, 30),
                        size: new google.maps.Size(30, 30),
                        anchor: new google.maps.Point(15, 15)
                    }
                }
            ];

            dispatch(addPointers([...tempPointers]));
        }else{
            dispatch(addPointers([]));
        }
    }, [
        formData?.startAddress?.latitude,
        formData?.startAddress?.longitude,
        formData?.startAddress?.address,
        formData?.endAddress?.latitude,
        formData?.endAddress?.longitude,
        formData?.endAddress?.address
    ]);

    const createRouteOnView = (startPoint, endPoint) => {
        const tempPointers = [
            {
                id: '1',
                lat: parseFloat(startPoint?.latitude || 0),
                lng: parseFloat(startPoint?.longitude || 0),
                label: formData?.startAddress?.address,
                heading: 0,
                color: '000',
                eventName: 'no event',
                draggable: true,
                updatePointers: true,
                hideMarker: true
            },
            {
                id: '2',
                lat: parseFloat(endPoint?.latitude || 0),
                lng: parseFloat(endPoint?.longitude || 0),
                label: formData?.endAddress?.address,
                heading: 0,
                color: '000',
                eventName: 'no event',
                draggable: true,
                updatePointers: true,
                hideMarker: true
            }
        ];

        dispatch(drawGetDirections(false))
        //save pointers and shows into map
        dispatch(addPointers([...tempPointers]));
        dispatch(setMapRoutesOptions(formData?.routeProperties));
    }

    useEffect(() => {
        if (pointers && pointers.length > 1) {
            dispatch(setMapRoutesOptions(formData?.routeProperties));
            //delete the old rounte on map
            mapRef?.current?.deleteRouteInMap()
            //create the new pointers of the view
            dispatch(drawGetDirections(true))

            if(!formData?.startAddress || !pointers[0].label){
                setFormData(formData => ({
                    ...formData,
                    startAddress:  { ...formData.startAddress, latitude: pointers[0].lat, longitude: pointers[0].lng }
                }))
                getDirection(pointers[0].lat, pointers[0].lng, "startPoint");
            }
            if(!formData?.endAddress || !pointers[1].label){
                setFormData(formData => ({
                    ...formData,
                    endAddress:  { ...formData.endAddress, latitude: pointers[1].lat, longitude: pointers[1].lng }
                }))
                getDirection(pointers[1].lat, pointers[1].lng, "endPoint");
            }
        }
    }, [pointers]);

    useEffect(() => {
        if(clickLatLng){
            if(formData?.startAddress?.address &&
                formData?.startAddress?.latitude &&
                formData?.endAddress?.address &&
                formData?.endAddress?.latitude){
                dispatch(selectCreateClickMapType(TypeObjectMap.Default))
                return
            }

            if(!formData?.startAddress?.address){
                setFormData(formData => ({
                    ...formData,
                    startAddress:  { ...formData.startAddress, latitude: clickLatLng.lat, longitude: clickLatLng.lng }
                }))
                //go to search address
                getDirection(clickLatLng.lat, clickLatLng.lng, "startPoint");

                if(!formData?.endAddress?.address){
                    //eval zoom on map
                    if(mapRef.current.getZoom() < 15){
                        mapRef.current.centerPointOnMap(clickLatLng.lat, clickLatLng.lng, 15)
                    }
                }

            }else if(!formData?.endAddress?.address){
                setFormData(formData => ({
                    ...formData,
                    endAddress:  { ...formData.endAddress, latitude: clickLatLng.lat, longitude: clickLatLng.lng }
                }))
                //go to search address
                getDirection(clickLatLng.lat, clickLatLng.lng, "endPoint");

            }
        }
    },[clickLatLng])

    useEffect(() => {
        if (address && address.result == true && open) {
            const { data, id } = address;
            if (data && data.length > 0) {
                const keyToUpdate = id == 'startPoint' ? 'startAddress' : 'endAddress'
                setFormData(formData => ({
                    ...formData,
                    [keyToUpdate] : {
                        ...formData[keyToUpdate],
                        tempAddress: data[0].fulladdress,
                        fulladdress: data[0].fulladdress,
                        address: data[0].address1,
                        city: data[0].city,
                        zip: data[0].postalcode,
                        state: data[0].state,
                        country: data[0].country
                    }
                }));
            }
        }
    }, [address, open]);

    useEffect(() => {

        if (response && open) {
            if (response.error) {

                let messageToShow = response.message == "Duplicated name for speed override" ? messages['speedOverride_create_error_name'] : response.message;
                messageToShow = messageToShow == "The Address points is already exist" ? messages['speedOverride_create_error_address'] : messageToShow;
                messageToShow = messageToShow == "The distance of the 2 points must be greater than 15 meters" ? messages['speedOverride_create_error_distance'] : messageToShow;


                NotificationManager.error(
                    messageToShow,
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
                dispatch(clearRedux("MAP_SPEED_OVERRIDE_CREATE_EDIT", { response: null }));
            } else {
                NotificationManager.success(
                    messages['speedOverride_create_sucessfull'],
                    messages['success'],
                    3000,
                    null,
                    null,
                    'success',
                );
                dispatch(mapSpeedOverrideClearSearch())
                handleClose();
            }
        }

    }, [response, open])

    useEffect(() => {
        if (speedOverride && open) {
            if (speedOverride.error) {
                NotificationManager.error(
                    messages['errorMessage'],
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
            } else {
                //edit mode
                let editSpeedOverrideData = {
                    ...speedOverride,
                    startAddress: speedOverride?.startAddress ? JSON.parse(speedOverride?.startAddress) : null,
                    endAddress: speedOverride?.endAddress ? JSON.parse(speedOverride?.endAddress) : null,
                    speedLimit: speedOverride?.speedLimit
                }

                let valueColor = getRouteColorFromSpeed(Math.round(speedOverride?.speedLimit || 0))
                const newRouteProperties = {...formData.routeProperties, color: valueColor?.color || defaulColorRoute }
                editSpeedOverrideData = {
                    ...editSpeedOverrideData,
                    routeProperties: newRouteProperties
                }

                //update the route color on map
                mapRef?.current?.updateRouteStyles(newRouteProperties);

                if(editSpeedOverrideData.startAddress && editSpeedOverrideData.endAddress){
                    editSpeedOverrideData = {
                        ...editSpeedOverrideData,
                        startAddress: {
                            ...editSpeedOverrideData.startAddress,
                            tempAddress: editSpeedOverrideData?.startAddress?.fulladdress
                        },
                        endAddress: {
                            ...editSpeedOverrideData.endAddress,
                            tempAddress: editSpeedOverrideData?.endAddress?.fulladdress
                        },
                    }
                }

                if(isKph){
                    editSpeedOverrideData = {
                        ...editSpeedOverrideData,
                        speedLimit : editSpeedOverrideData.speedLimit * 1.60934
                    }
                }

                //get the colors of lanmdarks tags
                setFormData({
                    ...editSpeedOverrideData
                });
            }
        }
    }, [speedOverride, open]);

    const getDirection = useCallback((lat, lng, controlId) => {
        onGetGeocoder({
            from: 'latlng', //latlng, address
            lat: lat,
            lng: lng,
            id: controlId
        })
    });

    const onSubmit = () => {
        if(isInvalidToSave()) return;

        //get the points for the map to update lat / lng for start and end address

        const startMarkerObject = mapRef.current.getObject(TypeObjectMap.Routes, 'temporalRouteMarker_startMarker');
        const endMarkerObject = mapRef.current.getObject(TypeObjectMap.Routes, 'temporalRouteMarker_endMarker');

        let newSpeedOverrideData = { ...formData };

        if(startMarkerObject && endMarkerObject){
            newSpeedOverrideData = {
                ...newSpeedOverrideData,
                startAddress: {
                    ...newSpeedOverrideData.startAddress,
                    latitude: startMarkerObject.instance.getPosition().lat(),
                    longitude: startMarkerObject.instance.getPosition().lng()
                },
                endAddress: {
                    ...newSpeedOverrideData.endAddress,
                    latitude: endMarkerObject.instance.getPosition().lat(),
                    longitude: endMarkerObject.instance.getPosition().lng(),
                }
            };
        }
        const valueEncodedPath = mapRef.current.getGeometryEncoded();

        if(!valueEncodedPath){
            //is necesary to create route
            NotificationManager.error(
                messages['speedOverride_create_route_valid'],
                messages['error'],
                3000,
                null,
                null,
                'warning',
            );
            return
        }

        let speedOverride = parseFloat(newSpeedOverrideData?.speedLimit);
        if(isKph){
            speedOverride = speedOverride * 0.621371;
        }

        const speedRouteData = mapRef.current.getObject(TypeObjectMap.Settings, 'drawSpeedRoute_dataForGoogleSpeed')

        if(formData?.id){
            //update info
            newSpeedOverrideData = {
                ...newSpeedOverrideData,
                id: id,
                startAddress: JSON.stringify(newSpeedOverrideData.startAddress),
                endAddress: JSON.stringify(newSpeedOverrideData.endAddress),
                encodedPath: valueEncodedPath,
                speedLimit: speedOverride,
                speedData: speedRouteData?.value || ''
            }
            dispatch(mapSpeedOverrideSaveSpeedOverride(newSpeedOverrideData))

        }else{
            //save data
            newSpeedOverrideData = {
                ...newSpeedOverrideData,
                startAddress: JSON.stringify(newSpeedOverrideData.startAddress),
                endAddress: JSON.stringify(newSpeedOverrideData.endAddress),
                encodedPath: valueEncodedPath,
                speedLimit: speedOverride,
                speedData: speedRouteData?.value || ''
            }
            dispatch(mapSpeedOverrideSaveSpeedOverride(newSpeedOverrideData))

        }
    }

    const isInvalidToSave = () => {
        let isInvalid = false;

        if(!formData?.name){
            isInvalid = true;
        }

        if(formData?.speedLimit <= 0){
            isInvalid = true;
        }

        //no have more than 2 points on map
        if(pointers?.length < 2){
            isInvalid = true;
        }

        if(!formData.startAddress || !formData.endAddress){
            isInvalid = true;
        }

        return isInvalid;
    }

    const TitleSpeedOverride = () => {
        return(
            !loadingSpeedOverride
            ?
            <div style={{ top: 0, padding: '25px 0px 30px 25px', zindex: 1 }}>
                <Grid
                    container
                    spacing={2}
                >
                    <Grid item>
                        <Button
                            type="icon"
                            icon="arrow_back"
                            tooltip={messages['back']}
                            onClick={handleClose}
                            className="btn-cancel"
                        >
                            {messages['routes_cancel']}
                        </Button>
                    </Grid>
                    <Grid item>
                        <h2 style={{ margin: 0, fontWeight: 400 }}>
                            {speedOverride?.id ? messages['speedOverride_create_edit_title'] : messages['speedOverride_create_title']}
                        </h2>
                    </Grid>
                </Grid>
            </div>
            :
            <></>
        )
    }

  return(
        <Modal
            title={<TitleSpeedOverride />}
            open={open || false}
            position="right"
            size="modal-extra-small"
            hiddenCloseButton
            hiddenStyleTitle
            className="class-modal-speed-override"
            headerStyle={{ top: 0 }}
        >
            <ModalBody hideDefaultStyles >
                {
                loadingSpeedOverride ?
                    <Loading full />
                    :
                    <Form ref={formCreateSpeedOverride} onValidSubmit={onSubmit}>
                        <div style={{ padding: '0px 24px 24px 24px', minHeight: 700 }}>
                            <Grid
                                container
                                direction="column"
                                justifyContent="flex-start"
                                alignItems="stretch"
                            >
                                <Grid item>
                                    <Typography
                                        variant="subtitle1"
                                        className='speed-override-subtitle'
                                    >
                                        {messages['speedOverride_create_info']}
                                    </Typography>
                                </Grid>
                                <Grid item style={{ width: '100%', overflow: 'hidden' }}>
                                    <Input
                                        id="name"
                                        //type={speedOverride ? "inline" : "text"}
                                        type={"text"}
                                        label={messages['speedOverride_create_label']}
                                        placeholder={messages['select']}
                                        value={formData?.name || ""}
                                        onChange={(value) => {
                                            setFormData(formData => ({
                                                ...formData,
                                                name: value
                                            }))
                                        }}
                                        required
                                        requiredMessage={messages['required_field']}
                                        maxLength={50}
                                    />
                                </Grid>
                                <Grid item>
                                    <Typography
                                            variant="subtitle1"
                                            className='speed-override-subtitle'
                                            style={{ color: 'black', paddingTop: 15}}
                                        >
                                            {messages['speedOverride_create_segment']}
                                        </Typography>
                                    </Grid>
                                <Grid item style={{ paddingTop: 10}}>
                                    <label className="input-normal-label">
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="center"
                                        >
                                            <Grid item>
                                                <Icon
                                                    style={{
                                                        color: routeProperties?.startPointColor || '#DF1A31',
                                                        fontSize: 16,
                                                        marginTop: 2,
                                                        marginRight: 2,
                                                        marginLeft: -3
                                                    }}
                                                >
                                                    location_on_icon
                                                </Icon>
                                            </Grid>
                                            <Grid item>
                                                {messages['speedOverride_create_start']}<span className="text-danger"> *</span>
                                            </Grid>
                                        </Grid>
                                    </label>
                                    <InputSearchMap
                                        normalView
                                        noMap
                                        hideClear
                                        placeholder={messages['search']}
                                        noOptionsText={messages['noOptions']}
                                        onGetAddress={(value) => {
                                            if (value && value?.length) {
                                                const data = value[0];
                                                setFormData(formData => ({
                                                    ...formData,
                                                    startAddress: {
                                                        address: data?.address1 || data?.fulladdress,
                                                        fulladdress : data?.fulladdress,
                                                        latitude: data.lat,
                                                        longitude: data.lng,
                                                        city: data.city,
                                                        zip: data.postalcode,
                                                        state: data.state,
                                                        country: data.country
                                                    }
                                                }));
                                                if(!formData.endAddress){
                                                    //eval zoom on map
                                                    if(mapRef.current.getZoom() < 15){
                                                        mapRef.current.centerPointOnMap(data.lat, data.lng, 15)
                                                    }
                                                }
                                            }else{
                                                setFormData(formData => ({
                                                    ...formData,
                                                    startAddress: null
                                                }));
                                                dispatch(selectCreateClickMapType(TypeObjectMap.MapClick))
                                            }
                                        }}
                                        onClear={() => {
                                        }}
                                        draggable={false}
                                        addressValue={formData?.startAddress?.tempAddress || ''}
                                        onClearSetAddress={()=>{
                                            setFormData(formData => ({
                                                ...formData,
                                                startAddress: {
                                                    ...formData.startAddress,
                                                    tempAddress : ""
                                                }
                                            }));
                                        }}
                                        onClearInput={()=>{
                                            setFormData(formData => ({
                                                ...formData,
                                                startAddress: null
                                            }));
                                            mapRef?.current?.deleteRouteInMap()
                                            dispatch(selectCreateClickMapType(TypeObjectMap.MapClick))
                                        }}
                                    />
                                </Grid>
                                <Grid item style={{ paddingTop: 10}}>
                                    <label className="input-normal-label">
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="center"
                                        >
                                            <Grid item>
                                                <Icon
                                                    style={{
                                                        color: routeProperties?.endPointColor || '#00B200',
                                                        fontSize: 16,
                                                        marginTop: 2,
                                                        marginRight: 2,
                                                        marginLeft: -3
                                                    }}
                                                >
                                                    location_on_icon
                                                </Icon>
                                            </Grid>
                                            <Grid item>
                                                {messages['speedOverride_create_end']}<span className="text-danger"> *</span>
                                            </Grid>
                                        </Grid>
                                    </label>
                                    <InputSearchMap
                                        normalView
                                        noMap
                                        hideClear
                                        placeholder={messages['search']}
                                        noOptionsText={messages['noOptions']}
                                        onGetAddress={(value) => {
                                            if (value && value?.length) {
                                                const data = value[0];
                                                setFormData(formData => ({
                                                    ...formData,
                                                    endAddress: {
                                                        address: data?.address1 || data?.fulladdress,
                                                        fulladdress : data?.fulladdress,
                                                        latitude: data.lat,
                                                        longitude: data.lng,
                                                        city: data.city,
                                                        zip: data.postalcode,
                                                        state: data.state,
                                                        country: data.country
                                                    }
                                                }));
                                            }else{
                                                setFormData(formData => ({
                                                    ...formData,
                                                    endAddress: null
                                                }));
                                                dispatch(selectCreateClickMapType(TypeObjectMap.MapClick))
                                            }
                                        }}
                                        onClear={() => {
                                        }}
                                        draggable={false}
                                        addressValue={formData?.endAddress?.tempAddress || ''}
                                        onClearSetAddress={()=>{
                                            setFormData(formData => ({
                                                ...formData,
                                                endAddress: {
                                                    ...formData.endAddress,
                                                    tempAddress : ""
                                                }
                                            }));
                                        }}
                                        onClearInput={()=>{
                                            setFormData(formData => ({
                                                ...formData,
                                                endAddress: null
                                            }));
                                            mapRef?.current?.deleteRouteInMap()
                                            dispatch(selectCreateClickMapType(TypeObjectMap.MapClick))
                                        }}
                                    />
                                </Grid>
                                <Grid item>
                                    <Input
                                        id="end"
                                        type={"number"}
                                        //regex="^\d*$"
                                        label={messages['speedOverride_create_correct_speedLimit']}
                                        placeholder={messages['select']}
                                        value={formData?.speedLimit ? Math.round(formData?.speedLimit) : ""}
                                        onChange={(paramValue) => {
                                            let value = paramValue;
                                            if(value <= 0) value = 0;
                                            let valueColor = getRouteColorFromSpeed(value)
                                            const newRouteProperties = {...formData.routeProperties, color: valueColor?.color || defaulColorRoute }
                                            setFormData(formData => ({
                                                ...formData,
                                                speedLimit: value,
                                                routeProperties: newRouteProperties
                                            }))

                                            //update the route color on map
                                            mapRef?.current?.updateRouteStyles(newRouteProperties);
                                        }}
                                        required
                                        requiredMessage={messages['required_field']}
                                        maxLength={3}
                                        className='box-container-in-view'
                                    />
                                </Grid>
                                <Grid item style={{ width: '100%', overflow: 'hidden' }}>
                                    <Input
                                        id="notes"
                                        type="textarea"
                                        className='input-normal speedOverride-textarea'
                                        label={messages['speedOverride_create_notes']}
                                        placeholder={messages['speedOverride_create_notes_placeholder']}
                                        value={formData?.notes || ""}
                                        onChange={(value) => setFormData(formData => ({
                                            ...formData,
                                            notes: value
                                        }))}
                                        maxLength={500} //DB TEXT type
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </Form>
                }
            </ModalBody>

            <ModalFooter style={{ bottom: 50, width: '100%' }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                >
                    <Grid item>
                        <Button
                            onClick={handleClose}
                            className="btn-cancel"
                        >
                            {messages['routes_cancel']}
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            disabled={loadingSpeedOverride || loadingResponse || isInvalidToSave() }
                            className="btn-blue"
                            onClick={(e) => {
                                e.preventDefault();
                                formCreateSpeedOverride.current.submit();
                            }}
                        >
                            {messages['routes_save']}
                        </Button>
                    </Grid>
                </Grid>
            </ModalFooter>
        </Modal>
    )
}

export default SpeedOverrideCreateEdit;
